import { FC } from 'react';
import 'swiper/css';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import RoutesComponent from '@/routes/Routes.component';
import { useAuthNavigation } from '@/hooks/useAuthNavigation';
import { useFavoritesList } from '@/hooks/useFavoritesList';
import { usePageMeta } from '@/hooks/usePageMeta';
import { YandexMetrika } from '@/components/analytics/YandexMetrika.component';
import { useMetrikaPageView } from '@/components/analytics/usePageView';
import ToastifyContainer from '@/components/elems/ToastifyContainer/ToastifyContainer.component';
import SiteLayout from '@/components/layouts/SiteLayout/SiteLayout.component';

dayjs.locale('ru');

export const App: FC = () => {
    useAuthNavigation();
    useFavoritesList();
    usePageMeta();
    useMetrikaPageView();

    return (
        <>
            <YandexMetrika />
            <ToastifyContainer />
            <SiteLayout>
                <RoutesComponent />
            </SiteLayout>
        </>
    );
};

export default App;
